import { send } from '../../../../../../src/network/network';
import { type CustomerDietaryRestriction } from '../../../../../../src/types/CustomerDietaryRestriction';
import { type PatchedCustomerDietaryRestriction } from '../../../../../../src/types/PatchedCustomerDietaryRestriction';

type Params = {
  requestBody: PatchedCustomerDietaryRestriction;
};

export async function patchApiV2CustomersCustomerIdDietaryRestrictions({
  requestBody,
}: Params) {
  return await send<CustomerDietaryRestriction>({
    path: `/api/v2/customers/self/dietary_restrictions/`,
    method: 'PATCH',
    body: requestBody,
  });
}
